module.exports = {"title":404,"path":"/404.html","layout":"page","body":"<p>该页面不存在。</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 509
// module chunks = 0